import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthenticationService } from '../../../services/authentication.service';
import { MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { HelpersService } from "../../../services/helpers.service";
import { UserService } from "../../../services/user.service";

@Component({
  selector: 'app-tfasetup',
  templateUrl: './tfasetup.component.html',
  styleUrls: ['./tfasetup.component.scss'],
  providers: [MessageService]
})
export class TFASetupComponent implements OnInit {

  tfaForm: FormGroup  = new FormGroup({
    code: new FormControl("", [
      Validators.required,
      (control) => {
        const value = control.value as string;
        if (value && value.length !== 6) {
          return { exactLength: true };
        }
        return null;
      },
    ])
  });

  skipIsBusy:boolean = false;

  isBusy: boolean = false;
  isLoading: boolean = true;
  tfaEnabled: boolean = false;
  showError: boolean = false;
  errorMessage: string = "";
  qrInfo: string = "";
  authenticatorKey: string = "";

  allowSkip: boolean = true;

  constructor(
    private route: ActivatedRoute, 
    public authService: AuthenticationService, 
    public messageService: MessageService, 
    public helpersService: HelpersService,
    public userService: UserService,
    public router: Router) 
  {
    // // Access the values from the service
    // console.log(this.authService.username);
    // console.log(this.authService.password);

    this.allowSkip = this.authService.allowSkip;
  }

  ngOnInit(){
    if(this.authService.username == null || this.authService.username == undefined)
    {
      this.router.navigateByUrl("");
      return;
    }

    this.generate2FAQrCode();
  }

  generate2FAQrCode(){
  this.authService.generate2FAQrCodeUri(this.authService.username).subscribe(result => {
    console.log('generate2FAQrCode');
    console.log(result);

    this.authenticatorKey = result.manualEntryKey;
    this.qrInfo = result.setupQrCode;
    this.isLoading = false;
  });
}

  validateControl(controlName: string){
    return this.tfaForm.get(controlName).invalid && this.tfaForm.get(controlName).touched;
  }

  hasError(controlName: string, errorName: string) {
    return this.tfaForm.get(controlName).hasError(errorName);
  }

  enableTfa(tfaFormValue: any){
    console.log(tfaFormValue);
    this.showError = false;
    this.errorMessage = "";
    this.isBusy = true;

    this.authService.register2FA(this.authService.username, this.authService.password, tfaFormValue.code).subscribe(result => {
      console.log('success');
      console.log(result);
      if(result.valid == false)
      {
        //Invalid code value received
        this.showError = true;
        this.errorMessage = "Invalid code, try again."
      }
      else{
        //Is valid, redirect to tfa code page
        this.router.navigateByUrl("/2facode");
        return;
      }

      this.isBusy = false;
    },
    error => {
      console.log('error');
      console.error(error);
      this.showError = true;
      this.errorMessage = "Failed to validate code."

      this.isBusy = false;
    });
  }  

  // skip(){
  //   if(!this.allowSkip)
  //   {
  //     return;
  //   }

  //   this.skipIsBusy = true;
  //   this.showError = false;
  //   this.errorMessage = "";

  //   this.authService.login(this.authService.username, this.authService.password, true).subscribe(
  //       (result) => {
  //         console.log(result);

  //         this.helpersService.saveAuthData(result);          
  //         this.helpersService.saveAuthDataNew(result);

  //         this.userService.getUserDetail(this.authService.username).subscribe(
  //           (user) => {

  //             const profile = user;
  //             const roles = profile.UserRoles.filter(x=>{return x.PartnerID > 0});
  //             var shops = roles.map(x=>{return x.PartnerID}).filter((value, index, self)=>{ 
  //               return self.indexOf(value) === index;
  //             });

  //             if(shops.length > 0){
  //               var defaultPartnerID = shops[0];
  //               profile.PartnerID = defaultPartnerID;

  //               var shopRoles = roles.filter(x=>{return x.PartnerID === defaultPartnerID}).map(x=>{return x.RoleID});
                
  //               profile.isAdmin = shopRoles.includes(2) || profile.UserRoles.includes(3);
  //               profile.isManager = shopRoles.includes(3);
  //               profile.isTechnician = (shopRoles.includes(1) || shopRoles.includes(4)) && !profile.isAdmin && !profile.isManager;
  //             }
  //             this.helpersService.saveProfileData(profile);

  //             this.userService.getUserRolesInsurance(profile.ID).subscribe(
  //               permissions => {
  //                 this.helpersService.saveProfileInsuranceRoles(permissions);
  //               },
  //               error => {
  //                 this.skipIsBusy = false;
  //               }
  //             );              

  //             if (this.authService.returnUrl) {
  //               this.router.navigateByUrl(this.authService.returnUrl);
  //             } else if (profile.IsSuperUser) {
  //               this.router.navigateByUrl("/administration/stores");
  //             } else if (
  //               profile.isAdmin || profile.isManager
  //             ) {
  //               this.router.navigateByUrl("/store/product-redirect-loader");
  //             } else if (profile.isTechnician) {
  //               this.router.navigateByUrl("/store/product-redirect-loader");
  //             } else {
  //               //if (isDevMode()) {
  //                 this.router.navigateByUrl("/clubs");
  //             }
  //           },
  //           (error) => {
  //             this.skipIsBusy = false;
  //             this.showError = true;
  //             this.errorMessage =
  //               "There was an error getting the user profile details. Please try again later.";
  //           }
  //         );
  //       },
  //       (error) => {
  //         this.skipIsBusy = false;
  //         this.showError = true;
  //         this.errorMessage =
  //           error && error.error_description
  //             ? error.error_description
  //             : "The email or password is incorrect.";
  //       }
  //     );
  // }

  home(){
    this.router.navigateByUrl('/');
  }
}